module.exports = __webpack_public_path__ + "static/media/44598594_2199900196751826_8746159118244380672_o.6d22895b.jpg";